module.exports = __webpack_public_path__ + "img/splash-platform-cabinet.14510b3.png";